/* eslint-disable prettier/prettier */
import type { AdonisEndpoint } from '@tuyau/core/types'
import type { Registry } from './schema.d.ts'
import type { ApiDefinition } from './tree.d.ts'

const placeholder: any = {}

const routes = {
  'logout.submit': {
    methods: ["GET","HEAD"],
    pattern: '/logout',
    tokens: [{"old":"/logout","type":0,"val":"logout","end":""}],
    types: placeholder as Registry['logout.submit']['types'],
  },
  'auth.pending': {
    methods: ["GET","HEAD"],
    pattern: '/auth/pending',
    tokens: [{"old":"/auth/pending","type":0,"val":"auth","end":""},{"old":"/auth/pending","type":0,"val":"pending","end":""}],
    types: placeholder as Registry['auth.pending']['types'],
  },
  'auth.trialExpired': {
    methods: ["GET","HEAD"],
    pattern: '/auth/trial-expired',
    tokens: [{"old":"/auth/trial-expired","type":0,"val":"auth","end":""},{"old":"/auth/trial-expired","type":0,"val":"trial-expired","end":""}],
    types: placeholder as Registry['auth.trialExpired']['types'],
  },
  'auth.redirect': {
    methods: ["GET","HEAD"],
    pattern: '/auth/:provider',
    tokens: [{"old":"/auth/:provider","type":0,"val":"auth","end":""},{"old":"/auth/:provider","type":1,"val":"provider","end":""}],
    types: placeholder as Registry['auth.redirect']['types'],
  },
  'auth.callback': {
    methods: ["GET","HEAD"],
    pattern: '/auth/:provider/callback',
    tokens: [{"old":"/auth/:provider/callback","type":0,"val":"auth","end":""},{"old":"/auth/:provider/callback","type":1,"val":"provider","end":""},{"old":"/auth/:provider/callback","type":0,"val":"callback","end":""}],
    types: placeholder as Registry['auth.callback']['types'],
  },
  'admin.users.index': {
    methods: ["GET","HEAD"],
    pattern: '/admin/users',
    tokens: [{"old":"/admin/users","type":0,"val":"admin","end":""},{"old":"/admin/users","type":0,"val":"users","end":""}],
    types: placeholder as Registry['admin.users.index']['types'],
  },
  'admin.users.show': {
    methods: ["GET","HEAD"],
    pattern: '/admin/users/:id',
    tokens: [{"old":"/admin/users/:id","type":0,"val":"admin","end":""},{"old":"/admin/users/:id","type":0,"val":"users","end":""},{"old":"/admin/users/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['admin.users.show']['types'],
  },
  'admin.users.delete': {
    methods: ["DELETE"],
    pattern: '/admin/users/:id',
    tokens: [{"old":"/admin/users/:id","type":0,"val":"admin","end":""},{"old":"/admin/users/:id","type":0,"val":"users","end":""},{"old":"/admin/users/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['admin.users.delete']['types'],
  },
  'admin.users.updateRole': {
    methods: ["PATCH"],
    pattern: '/admin/users/:id/role',
    tokens: [{"old":"/admin/users/:id/role","type":0,"val":"admin","end":""},{"old":"/admin/users/:id/role","type":0,"val":"users","end":""},{"old":"/admin/users/:id/role","type":1,"val":"id","end":""},{"old":"/admin/users/:id/role","type":0,"val":"role","end":""}],
    types: placeholder as Registry['admin.users.updateRole']['types'],
  },
  'admin.users.setTrial': {
    methods: ["POST"],
    pattern: '/admin/users/:id/trial',
    tokens: [{"old":"/admin/users/:id/trial","type":0,"val":"admin","end":""},{"old":"/admin/users/:id/trial","type":0,"val":"users","end":""},{"old":"/admin/users/:id/trial","type":1,"val":"id","end":""},{"old":"/admin/users/:id/trial","type":0,"val":"trial","end":""}],
    types: placeholder as Registry['admin.users.setTrial']['types'],
  },
  'admin.users.removeTrial': {
    methods: ["DELETE"],
    pattern: '/admin/users/:id/trial',
    tokens: [{"old":"/admin/users/:id/trial","type":0,"val":"admin","end":""},{"old":"/admin/users/:id/trial","type":0,"val":"users","end":""},{"old":"/admin/users/:id/trial","type":1,"val":"id","end":""},{"old":"/admin/users/:id/trial","type":0,"val":"trial","end":""}],
    types: placeholder as Registry['admin.users.removeTrial']['types'],
  },
  'appraise.setup': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/appraise/setup',
    tokens: [{"old":"/projects/:id/appraise/setup","type":0,"val":"projects","end":""},{"old":"/projects/:id/appraise/setup","type":1,"val":"id","end":""},{"old":"/projects/:id/appraise/setup","type":0,"val":"appraise","end":""},{"old":"/projects/:id/appraise/setup","type":0,"val":"setup","end":""}],
    types: placeholder as Registry['appraise.setup']['types'],
  },
  'appraise.storeFramework': {
    methods: ["POST"],
    pattern: '/projects/:id/appraise/setup',
    tokens: [{"old":"/projects/:id/appraise/setup","type":0,"val":"projects","end":""},{"old":"/projects/:id/appraise/setup","type":1,"val":"id","end":""},{"old":"/projects/:id/appraise/setup","type":0,"val":"appraise","end":""},{"old":"/projects/:id/appraise/setup","type":0,"val":"setup","end":""}],
    types: placeholder as Registry['appraise.storeFramework']['types'],
  },
  'appraise.articles': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/appraise/articles',
    tokens: [{"old":"/projects/:id/appraise/articles","type":0,"val":"projects","end":""},{"old":"/projects/:id/appraise/articles","type":1,"val":"id","end":""},{"old":"/projects/:id/appraise/articles","type":0,"val":"appraise","end":""},{"old":"/projects/:id/appraise/articles","type":0,"val":"articles","end":""}],
    types: placeholder as Registry['appraise.articles']['types'],
  },
  'appraise.article': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/:displayId/appraise',
    tokens: [{"old":"/projects/:id/references/:displayId/appraise","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/appraise","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/appraise","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/appraise","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/appraise","type":0,"val":"appraise","end":""}],
    types: placeholder as Registry['appraise.article']['types'],
  },
  'appraise.validate': {
    methods: ["POST"],
    pattern: '/projects/:id/references/:displayId/appraise/validate',
    tokens: [{"old":"/projects/:id/references/:displayId/appraise/validate","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/appraise/validate","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/appraise/validate","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/appraise/validate","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/appraise/validate","type":0,"val":"appraise","end":""},{"old":"/projects/:id/references/:displayId/appraise/validate","type":0,"val":"validate","end":""}],
    types: placeholder as Registry['appraise.validate']['types'],
  },
  'designQuery.index': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/design-query',
    tokens: [{"old":"/projects/:id/design-query","type":0,"val":"projects","end":""},{"old":"/projects/:id/design-query","type":1,"val":"id","end":""},{"old":"/projects/:id/design-query","type":0,"val":"design-query","end":""}],
    types: placeholder as Registry['designQuery.index']['types'],
  },
  'designQuery.preview': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/design-query/preview',
    tokens: [{"old":"/projects/:id/design-query/preview","type":0,"val":"projects","end":""},{"old":"/projects/:id/design-query/preview","type":1,"val":"id","end":""},{"old":"/projects/:id/design-query/preview","type":0,"val":"design-query","end":""},{"old":"/projects/:id/design-query/preview","type":0,"val":"preview","end":""}],
    types: placeholder as Registry['designQuery.preview']['types'],
  },
  'designQuery.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/design-query/:sqOrder',
    tokens: [{"old":"/projects/:id/design-query/:sqOrder","type":0,"val":"projects","end":""},{"old":"/projects/:id/design-query/:sqOrder","type":1,"val":"id","end":""},{"old":"/projects/:id/design-query/:sqOrder","type":0,"val":"design-query","end":""},{"old":"/projects/:id/design-query/:sqOrder","type":1,"val":"sqOrder","end":""}],
    types: placeholder as Registry['designQuery.show']['types'],
  },
  'designQuery.autosave': {
    methods: ["POST"],
    pattern: '/projects/:id/design-query/autosave',
    tokens: [{"old":"/projects/:id/design-query/autosave","type":0,"val":"projects","end":""},{"old":"/projects/:id/design-query/autosave","type":1,"val":"id","end":""},{"old":"/projects/:id/design-query/autosave","type":0,"val":"design-query","end":""},{"old":"/projects/:id/design-query/autosave","type":0,"val":"autosave","end":""}],
    types: placeholder as Registry['designQuery.autosave']['types'],
  },
  'designQuery.store': {
    methods: ["POST"],
    pattern: '/projects/:id/design-query',
    tokens: [{"old":"/projects/:id/design-query","type":0,"val":"projects","end":""},{"old":"/projects/:id/design-query","type":1,"val":"id","end":""},{"old":"/projects/:id/design-query","type":0,"val":"design-query","end":""}],
    types: placeholder as Registry['designQuery.store']['types'],
  },
  'dois.metadata': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/dois/metadata',
    tokens: [{"old":"/api/v1/dois/metadata","type":0,"val":"api","end":""},{"old":"/api/v1/dois/metadata","type":0,"val":"v1","end":""},{"old":"/api/v1/dois/metadata","type":0,"val":"dois","end":""},{"old":"/api/v1/dois/metadata","type":0,"val":"metadata","end":""}],
    types: placeholder as Registry['dois.metadata']['types'],
  },
  'picoTables.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pico-tables',
    tokens: [{"old":"/projects/:id/pico-tables","type":0,"val":"projects","end":""},{"old":"/projects/:id/pico-tables","type":1,"val":"id","end":""},{"old":"/projects/:id/pico-tables","type":0,"val":"pico-tables","end":""}],
    types: placeholder as Registry['picoTables.show']['types'],
  },
  'picoTables.store': {
    methods: ["POST"],
    pattern: '/projects/:id/pico-tables',
    tokens: [{"old":"/projects/:id/pico-tables","type":0,"val":"projects","end":""},{"old":"/projects/:id/pico-tables","type":1,"val":"id","end":""},{"old":"/projects/:id/pico-tables","type":0,"val":"pico-tables","end":""}],
    types: placeholder as Registry['picoTables.store']['types'],
  },
  'references.import': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references',
    tokens: [{"old":"/projects/:id/references","type":0,"val":"projects","end":""},{"old":"/projects/:id/references","type":1,"val":"id","end":""},{"old":"/projects/:id/references","type":0,"val":"references","end":""}],
    types: placeholder as Registry['references.import']['types'],
  },
  'references.bulkImport': {
    methods: ["POST"],
    pattern: '/projects/:id/references/import',
    tokens: [{"old":"/projects/:id/references/import","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/import","type":1,"val":"id","end":""},{"old":"/projects/:id/references/import","type":0,"val":"references","end":""},{"old":"/projects/:id/references/import","type":0,"val":"import","end":""}],
    types: placeholder as Registry['references.bulkImport']['types'],
  },
  'references.importFile': {
    methods: ["POST"],
    pattern: '/projects/:id/references/import-file',
    tokens: [{"old":"/projects/:id/references/import-file","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/import-file","type":1,"val":"id","end":""},{"old":"/projects/:id/references/import-file","type":0,"val":"references","end":""},{"old":"/projects/:id/references/import-file","type":0,"val":"import-file","end":""}],
    types: placeholder as Registry['references.importFile']['types'],
  },
  'references.startJob': {
    methods: ["POST"],
    pattern: '/projects/:id/reference-batches/start',
    tokens: [{"old":"/projects/:id/reference-batches/start","type":0,"val":"projects","end":""},{"old":"/projects/:id/reference-batches/start","type":1,"val":"id","end":""},{"old":"/projects/:id/reference-batches/start","type":0,"val":"reference-batches","end":""},{"old":"/projects/:id/reference-batches/start","type":0,"val":"start","end":""}],
    types: placeholder as Registry['references.startJob']['types'],
  },
  'references.deleteBatch': {
    methods: ["DELETE"],
    pattern: '/projects/:id/reference-batches/:batchId',
    tokens: [{"old":"/projects/:id/reference-batches/:batchId","type":0,"val":"projects","end":""},{"old":"/projects/:id/reference-batches/:batchId","type":1,"val":"id","end":""},{"old":"/projects/:id/reference-batches/:batchId","type":0,"val":"reference-batches","end":""},{"old":"/projects/:id/reference-batches/:batchId","type":1,"val":"batchId","end":""}],
    types: placeholder as Registry['references.deleteBatch']['types'],
  },
  'references.duplicates': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/duplicate-references',
    tokens: [{"old":"/projects/:id/duplicate-references","type":0,"val":"projects","end":""},{"old":"/projects/:id/duplicate-references","type":1,"val":"id","end":""},{"old":"/projects/:id/duplicate-references","type":0,"val":"duplicate-references","end":""}],
    types: placeholder as Registry['references.duplicates']['types'],
  },
  'references.duplicates.detect': {
    methods: ["POST"],
    pattern: '/projects/:id/duplicate-references/detect',
    tokens: [{"old":"/projects/:id/duplicate-references/detect","type":0,"val":"projects","end":""},{"old":"/projects/:id/duplicate-references/detect","type":1,"val":"id","end":""},{"old":"/projects/:id/duplicate-references/detect","type":0,"val":"duplicate-references","end":""},{"old":"/projects/:id/duplicate-references/detect","type":0,"val":"detect","end":""}],
    types: placeholder as Registry['references.duplicates.detect']['types'],
  },
  'references.duplicates.detect.current': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/duplicate-references/detect/current',
    tokens: [{"old":"/projects/:id/duplicate-references/detect/current","type":0,"val":"projects","end":""},{"old":"/projects/:id/duplicate-references/detect/current","type":1,"val":"id","end":""},{"old":"/projects/:id/duplicate-references/detect/current","type":0,"val":"duplicate-references","end":""},{"old":"/projects/:id/duplicate-references/detect/current","type":0,"val":"detect","end":""},{"old":"/projects/:id/duplicate-references/detect/current","type":0,"val":"current","end":""}],
    types: placeholder as Registry['references.duplicates.detect.current']['types'],
  },
  'references.duplicates.detect.cancel': {
    methods: ["DELETE"],
    pattern: '/projects/:id/duplicate-references/detect',
    tokens: [{"old":"/projects/:id/duplicate-references/detect","type":0,"val":"projects","end":""},{"old":"/projects/:id/duplicate-references/detect","type":1,"val":"id","end":""},{"old":"/projects/:id/duplicate-references/detect","type":0,"val":"duplicate-references","end":""},{"old":"/projects/:id/duplicate-references/detect","type":0,"val":"detect","end":""}],
    types: placeholder as Registry['references.duplicates.detect.cancel']['types'],
  },
  'references.duplicates.mark': {
    methods: ["POST"],
    pattern: '/projects/:id/duplicate-references/mark',
    tokens: [{"old":"/projects/:id/duplicate-references/mark","type":0,"val":"projects","end":""},{"old":"/projects/:id/duplicate-references/mark","type":1,"val":"id","end":""},{"old":"/projects/:id/duplicate-references/mark","type":0,"val":"duplicate-references","end":""},{"old":"/projects/:id/duplicate-references/mark","type":0,"val":"mark","end":""}],
    types: placeholder as Registry['references.duplicates.mark']['types'],
  },
  'runQueries.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/run-queries',
    tokens: [{"old":"/projects/:id/run-queries","type":0,"val":"projects","end":""},{"old":"/projects/:id/run-queries","type":1,"val":"id","end":""},{"old":"/projects/:id/run-queries","type":0,"val":"run-queries","end":""}],
    types: placeholder as Registry['runQueries.show']['types'],
  },
  'runQueries.store': {
    methods: ["POST"],
    pattern: '/projects/:id/run-queries',
    tokens: [{"old":"/projects/:id/run-queries","type":0,"val":"projects","end":""},{"old":"/projects/:id/run-queries","type":1,"val":"id","end":""},{"old":"/projects/:id/run-queries","type":0,"val":"run-queries","end":""}],
    types: placeholder as Registry['runQueries.store']['types'],
  },
  'searchQuestions.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/search-questions',
    tokens: [{"old":"/projects/:id/search-questions","type":0,"val":"projects","end":""},{"old":"/projects/:id/search-questions","type":1,"val":"id","end":""},{"old":"/projects/:id/search-questions","type":0,"val":"search-questions","end":""}],
    types: placeholder as Registry['searchQuestions.show']['types'],
  },
  'searchQuestions.store': {
    methods: ["POST"],
    pattern: '/projects/:id/search-questions',
    tokens: [{"old":"/projects/:id/search-questions","type":0,"val":"projects","end":""},{"old":"/projects/:id/search-questions","type":1,"val":"id","end":""},{"old":"/projects/:id/search-questions","type":0,"val":"search-questions","end":""}],
    types: placeholder as Registry['searchQuestions.store']['types'],
  },
  'searchQuestions.validate': {
    methods: ["POST"],
    pattern: '/projects/:id/search-questions/validate',
    tokens: [{"old":"/projects/:id/search-questions/validate","type":0,"val":"projects","end":""},{"old":"/projects/:id/search-questions/validate","type":1,"val":"id","end":""},{"old":"/projects/:id/search-questions/validate","type":0,"val":"search-questions","end":""},{"old":"/projects/:id/search-questions/validate","type":0,"val":"validate","end":""}],
    types: placeholder as Registry['searchQuestions.validate']['types'],
  },
  'device.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/device',
    tokens: [{"old":"/projects/:id/device","type":0,"val":"projects","end":""},{"old":"/projects/:id/device","type":1,"val":"id","end":""},{"old":"/projects/:id/device","type":0,"val":"device","end":""}],
    types: placeholder as Registry['device.show']['types'],
  },
  'device.store': {
    methods: ["POST"],
    pattern: '/projects/:id/device',
    tokens: [{"old":"/projects/:id/device","type":0,"val":"projects","end":""},{"old":"/projects/:id/device","type":1,"val":"id","end":""},{"old":"/projects/:id/device","type":0,"val":"device","end":""}],
    types: placeholder as Registry['device.store']['types'],
  },
  'device.validateSections': {
    methods: ["POST"],
    pattern: '/projects/:id/device/validate-sections',
    tokens: [{"old":"/projects/:id/device/validate-sections","type":0,"val":"projects","end":""},{"old":"/projects/:id/device/validate-sections","type":1,"val":"id","end":""},{"old":"/projects/:id/device/validate-sections","type":0,"val":"device","end":""},{"old":"/projects/:id/device/validate-sections","type":0,"val":"validate-sections","end":""}],
    types: placeholder as Registry['device.validateSections']['types'],
  },
  'device.deleteSection': {
    methods: ["DELETE"],
    pattern: '/projects/:id/device/sections/:sectionId',
    tokens: [{"old":"/projects/:id/device/sections/:sectionId","type":0,"val":"projects","end":""},{"old":"/projects/:id/device/sections/:sectionId","type":1,"val":"id","end":""},{"old":"/projects/:id/device/sections/:sectionId","type":0,"val":"device","end":""},{"old":"/projects/:id/device/sections/:sectionId","type":0,"val":"sections","end":""},{"old":"/projects/:id/device/sections/:sectionId","type":1,"val":"sectionId","end":""}],
    types: placeholder as Registry['device.deleteSection']['types'],
  },
  'extract.setup': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/extract/setup',
    tokens: [{"old":"/projects/:id/extract/setup","type":0,"val":"projects","end":""},{"old":"/projects/:id/extract/setup","type":1,"val":"id","end":""},{"old":"/projects/:id/extract/setup","type":0,"val":"extract","end":""},{"old":"/projects/:id/extract/setup","type":0,"val":"setup","end":""}],
    types: placeholder as Registry['extract.setup']['types'],
  },
  'extract.storeFields': {
    methods: ["POST"],
    pattern: '/projects/:id/extract/setup',
    tokens: [{"old":"/projects/:id/extract/setup","type":0,"val":"projects","end":""},{"old":"/projects/:id/extract/setup","type":1,"val":"id","end":""},{"old":"/projects/:id/extract/setup","type":0,"val":"extract","end":""},{"old":"/projects/:id/extract/setup","type":0,"val":"setup","end":""}],
    types: placeholder as Registry['extract.storeFields']['types'],
  },
  'extract.articles': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/extract/articles',
    tokens: [{"old":"/projects/:id/extract/articles","type":0,"val":"projects","end":""},{"old":"/projects/:id/extract/articles","type":1,"val":"id","end":""},{"old":"/projects/:id/extract/articles","type":0,"val":"extract","end":""},{"old":"/projects/:id/extract/articles","type":0,"val":"articles","end":""}],
    types: placeholder as Registry['extract.articles']['types'],
  },
  'extract.article': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/:displayId/extract',
    tokens: [{"old":"/projects/:id/references/:displayId/extract","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/extract","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/extract","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/extract","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/extract","type":0,"val":"extract","end":""}],
    types: placeholder as Registry['extract.article']['types'],
  },
  'extract.validate': {
    methods: ["POST"],
    pattern: '/projects/:id/references/:displayId/extract/validate',
    tokens: [{"old":"/projects/:id/references/:displayId/extract/validate","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/extract/validate","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/extract/validate","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/extract/validate","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/extract/validate","type":0,"val":"extract","end":""},{"old":"/projects/:id/references/:displayId/extract/validate","type":0,"val":"validate","end":""}],
    types: placeholder as Registry['extract.validate']['types'],
  },
  'extract.storeCustomField': {
    methods: ["POST"],
    pattern: '/projects/:id/extract/fields',
    tokens: [{"old":"/projects/:id/extract/fields","type":0,"val":"projects","end":""},{"old":"/projects/:id/extract/fields","type":1,"val":"id","end":""},{"old":"/projects/:id/extract/fields","type":0,"val":"extract","end":""},{"old":"/projects/:id/extract/fields","type":0,"val":"fields","end":""}],
    types: placeholder as Registry['extract.storeCustomField']['types'],
  },
  'extract.updateCustomField': {
    methods: ["PATCH"],
    pattern: '/projects/:id/extract/fields/:fieldId',
    tokens: [{"old":"/projects/:id/extract/fields/:fieldId","type":0,"val":"projects","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":1,"val":"id","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":0,"val":"extract","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":0,"val":"fields","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":1,"val":"fieldId","end":""}],
    types: placeholder as Registry['extract.updateCustomField']['types'],
  },
  'extract.destroyCustomField': {
    methods: ["DELETE"],
    pattern: '/projects/:id/extract/fields/:fieldId',
    tokens: [{"old":"/projects/:id/extract/fields/:fieldId","type":0,"val":"projects","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":1,"val":"id","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":0,"val":"extract","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":0,"val":"fields","end":""},{"old":"/projects/:id/extract/fields/:fieldId","type":1,"val":"fieldId","end":""}],
    types: placeholder as Registry['extract.destroyCustomField']['types'],
  },
  'proxy.pdf.head': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/proxy-pdf-head',
    tokens: [{"old":"/api/v1/proxy-pdf-head","type":0,"val":"api","end":""},{"old":"/api/v1/proxy-pdf-head","type":0,"val":"v1","end":""},{"old":"/api/v1/proxy-pdf-head","type":0,"val":"proxy-pdf-head","end":""}],
    types: placeholder as Registry['proxy.pdf.head']['types'],
  },
  'proxy.pdf.fetch': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/proxy-pdf-fetch',
    tokens: [{"old":"/api/v1/proxy-pdf-fetch","type":0,"val":"api","end":""},{"old":"/api/v1/proxy-pdf-fetch","type":0,"val":"v1","end":""},{"old":"/api/v1/proxy-pdf-fetch","type":0,"val":"proxy-pdf-fetch","end":""}],
    types: placeholder as Registry['proxy.pdf.fetch']['types'],
  },
  'pdf_indexing.start_project': {
    methods: ["POST"],
    pattern: '/projects/:id/pdf-indexing/start',
    tokens: [{"old":"/projects/:id/pdf-indexing/start","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdf-indexing/start","type":1,"val":"id","end":""},{"old":"/projects/:id/pdf-indexing/start","type":0,"val":"pdf-indexing","end":""},{"old":"/projects/:id/pdf-indexing/start","type":0,"val":"start","end":""}],
    types: placeholder as Registry['pdf_indexing.start_project']['types'],
  },
  'pdf_indexing.start_pdf': {
    methods: ["POST"],
    pattern: '/pdfs/:pdfId/index',
    tokens: [{"old":"/pdfs/:pdfId/index","type":0,"val":"pdfs","end":""},{"old":"/pdfs/:pdfId/index","type":1,"val":"pdfId","end":""},{"old":"/pdfs/:pdfId/index","type":0,"val":"index","end":""}],
    types: placeholder as Registry['pdf_indexing.start_pdf']['types'],
  },
  'pdf_indexing.project_status': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pdf-indexing/status',
    tokens: [{"old":"/projects/:id/pdf-indexing/status","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdf-indexing/status","type":1,"val":"id","end":""},{"old":"/projects/:id/pdf-indexing/status","type":0,"val":"pdf-indexing","end":""},{"old":"/projects/:id/pdf-indexing/status","type":0,"val":"status","end":""}],
    types: placeholder as Registry['pdf_indexing.project_status']['types'],
  },
  'pdf_indexing.pdf_status': {
    methods: ["GET","HEAD"],
    pattern: '/pdfs/:pdfId/index/status',
    tokens: [{"old":"/pdfs/:pdfId/index/status","type":0,"val":"pdfs","end":""},{"old":"/pdfs/:pdfId/index/status","type":1,"val":"pdfId","end":""},{"old":"/pdfs/:pdfId/index/status","type":0,"val":"index","end":""},{"old":"/pdfs/:pdfId/index/status","type":0,"val":"status","end":""}],
    types: placeholder as Registry['pdf_indexing.pdf_status']['types'],
  },
  'pdf_indexing.current': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pdf-indexing/current',
    tokens: [{"old":"/projects/:id/pdf-indexing/current","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdf-indexing/current","type":1,"val":"id","end":""},{"old":"/projects/:id/pdf-indexing/current","type":0,"val":"pdf-indexing","end":""},{"old":"/projects/:id/pdf-indexing/current","type":0,"val":"current","end":""}],
    types: placeholder as Registry['pdf_indexing.current']['types'],
  },
  'pdf_indexing.cancel': {
    methods: ["DELETE"],
    pattern: '/pdf-indexing/jobs/:jobId',
    tokens: [{"old":"/pdf-indexing/jobs/:jobId","type":0,"val":"pdf-indexing","end":""},{"old":"/pdf-indexing/jobs/:jobId","type":0,"val":"jobs","end":""},{"old":"/pdf-indexing/jobs/:jobId","type":1,"val":"jobId","end":""}],
    types: placeholder as Registry['pdf_indexing.cancel']['types'],
  },
  'prisma.index': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/prisma',
    tokens: [{"old":"/projects/:id/prisma","type":0,"val":"projects","end":""},{"old":"/projects/:id/prisma","type":1,"val":"id","end":""},{"old":"/projects/:id/prisma","type":0,"val":"prisma","end":""}],
    types: placeholder as Registry['prisma.index']['types'],
  },
  'prisma.export': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/prisma/export',
    tokens: [{"old":"/projects/:id/prisma/export","type":0,"val":"projects","end":""},{"old":"/projects/:id/prisma/export","type":1,"val":"id","end":""},{"old":"/projects/:id/prisma/export","type":0,"val":"prisma","end":""},{"old":"/projects/:id/prisma/export","type":0,"val":"export","end":""}],
    types: placeholder as Registry['prisma.export']['types'],
  },
  'dashboard.index': {
    methods: ["GET","HEAD"],
    pattern: '/dashboard',
    tokens: [{"old":"/dashboard","type":0,"val":"dashboard","end":""}],
    types: placeholder as Registry['dashboard.index']['types'],
  },
  'projects.index': {
    methods: ["GET","HEAD"],
    pattern: '/projects',
    tokens: [{"old":"/projects","type":0,"val":"projects","end":""}],
    types: placeholder as Registry['projects.index']['types'],
  },
  'projects.store': {
    methods: ["POST"],
    pattern: '/projects',
    tokens: [{"old":"/projects","type":0,"val":"projects","end":""}],
    types: placeholder as Registry['projects.store']['types'],
  },
  'projects.open': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/open',
    tokens: [{"old":"/projects/:id/open","type":0,"val":"projects","end":""},{"old":"/projects/:id/open","type":1,"val":"id","end":""},{"old":"/projects/:id/open","type":0,"val":"open","end":""}],
    types: placeholder as Registry['projects.open']['types'],
  },
  'projects.update': {
    methods: ["PATCH"],
    pattern: '/projects/:id',
    tokens: [{"old":"/projects/:id","type":0,"val":"projects","end":""},{"old":"/projects/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['projects.update']['types'],
  },
  'projects.destroy': {
    methods: ["DELETE"],
    pattern: '/projects/:id',
    tokens: [{"old":"/projects/:id","type":0,"val":"projects","end":""},{"old":"/projects/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['projects.destroy']['types'],
  },
  'projects.add_member': {
    methods: ["POST"],
    pattern: '/projects/:id/members',
    tokens: [{"old":"/projects/:id/members","type":0,"val":"projects","end":""},{"old":"/projects/:id/members","type":1,"val":"id","end":""},{"old":"/projects/:id/members","type":0,"val":"members","end":""}],
    types: placeholder as Registry['projects.add_member']['types'],
  },
  'projects.remove_member': {
    methods: ["DELETE"],
    pattern: '/projects/:id/members/:userId',
    tokens: [{"old":"/projects/:id/members/:userId","type":0,"val":"projects","end":""},{"old":"/projects/:id/members/:userId","type":1,"val":"id","end":""},{"old":"/projects/:id/members/:userId","type":0,"val":"members","end":""},{"old":"/projects/:id/members/:userId","type":1,"val":"userId","end":""}],
    types: placeholder as Registry['projects.remove_member']['types'],
  },
  'workflowConfiguration.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/scope',
    tokens: [{"old":"/projects/:id/scope","type":0,"val":"projects","end":""},{"old":"/projects/:id/scope","type":1,"val":"id","end":""},{"old":"/projects/:id/scope","type":0,"val":"scope","end":""}],
    types: placeholder as Registry['workflowConfiguration.show']['types'],
  },
  'workflowConfiguration.store': {
    methods: ["POST"],
    pattern: '/projects/:id/scope',
    tokens: [{"old":"/projects/:id/scope","type":0,"val":"projects","end":""},{"old":"/projects/:id/scope","type":1,"val":"id","end":""},{"old":"/projects/:id/scope","type":0,"val":"scope","end":""}],
    types: placeholder as Registry['workflowConfiguration.store']['types'],
  },
  'references.export': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/export',
    tokens: [{"old":"/projects/:id/references/export","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/export","type":1,"val":"id","end":""},{"old":"/projects/:id/references/export","type":0,"val":"references","end":""},{"old":"/projects/:id/references/export","type":0,"val":"export","end":""}],
    types: placeholder as Registry['references.export']['types'],
  },
  'references.notes.put': {
    methods: ["PUT"],
    pattern: '/references/:id/notes',
    tokens: [{"old":"/references/:id/notes","type":0,"val":"references","end":""},{"old":"/references/:id/notes","type":1,"val":"id","end":""},{"old":"/references/:id/notes","type":0,"val":"notes","end":""}],
    types: placeholder as Registry['references.notes.put']['types'],
  },
  'references.notes.delete': {
    methods: ["DELETE"],
    pattern: '/references/:id/notes',
    tokens: [{"old":"/references/:id/notes","type":0,"val":"references","end":""},{"old":"/references/:id/notes","type":1,"val":"id","end":""},{"old":"/references/:id/notes","type":0,"val":"notes","end":""}],
    types: placeholder as Registry['references.notes.delete']['types'],
  },
  'api.references.abstractSuggestions': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/references/:id/abstract-suggestions',
    tokens: [{"old":"/api/v1/references/:id/abstract-suggestions","type":0,"val":"api","end":""},{"old":"/api/v1/references/:id/abstract-suggestions","type":0,"val":"v1","end":""},{"old":"/api/v1/references/:id/abstract-suggestions","type":0,"val":"references","end":""},{"old":"/api/v1/references/:id/abstract-suggestions","type":1,"val":"id","end":""},{"old":"/api/v1/references/:id/abstract-suggestions","type":0,"val":"abstract-suggestions","end":""}],
    types: placeholder as Registry['api.references.abstractSuggestions']['types'],
  },
  'api.references.enrichedMetadata': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/references/:id/enriched-metadata',
    tokens: [{"old":"/api/v1/references/:id/enriched-metadata","type":0,"val":"api","end":""},{"old":"/api/v1/references/:id/enriched-metadata","type":0,"val":"v1","end":""},{"old":"/api/v1/references/:id/enriched-metadata","type":0,"val":"references","end":""},{"old":"/api/v1/references/:id/enriched-metadata","type":1,"val":"id","end":""},{"old":"/api/v1/references/:id/enriched-metadata","type":0,"val":"enriched-metadata","end":""}],
    types: placeholder as Registry['api.references.enrichedMetadata']['types'],
  },
  'references.importSuggestion': {
    methods: ["POST"],
    pattern: '/references/import-suggestion',
    tokens: [{"old":"/references/import-suggestion","type":0,"val":"references","end":""},{"old":"/references/import-suggestion","type":0,"val":"import-suggestion","end":""}],
    types: placeholder as Registry['references.importSuggestion']['types'],
  },
  'reference.tags.store': {
    methods: ["POST"],
    pattern: '/references/:id/tags',
    tokens: [{"old":"/references/:id/tags","type":0,"val":"references","end":""},{"old":"/references/:id/tags","type":1,"val":"id","end":""},{"old":"/references/:id/tags","type":0,"val":"tags","end":""}],
    types: placeholder as Registry['reference.tags.store']['types'],
  },
  'reference.tags.destroy': {
    methods: ["DELETE"],
    pattern: '/references/:id/tags/:tagId',
    tokens: [{"old":"/references/:id/tags/:tagId","type":0,"val":"references","end":""},{"old":"/references/:id/tags/:tagId","type":1,"val":"id","end":""},{"old":"/references/:id/tags/:tagId","type":0,"val":"tags","end":""},{"old":"/references/:id/tags/:tagId","type":1,"val":"tagId","end":""}],
    types: placeholder as Registry['reference.tags.destroy']['types'],
  },
  'references.nextForReview': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/next-for-review',
    tokens: [{"old":"/projects/:id/references/next-for-review","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/next-for-review","type":1,"val":"id","end":""},{"old":"/projects/:id/references/next-for-review","type":0,"val":"references","end":""},{"old":"/projects/:id/references/next-for-review","type":0,"val":"next-for-review","end":""}],
    types: placeholder as Registry['references.nextForReview']['types'],
  },
  'references.show': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/:displayId',
    tokens: [{"old":"/projects/:id/references/:displayId","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId","type":1,"val":"displayId","end":""}],
    types: placeholder as Registry['references.show']['types'],
  },
  'references.showPdf': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/:displayId/pdf',
    tokens: [{"old":"/projects/:id/references/:displayId/pdf","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/pdf","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/pdf","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/pdf","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/pdf","type":0,"val":"pdf","end":""}],
    types: placeholder as Registry['references.showPdf']['types'],
  },
  'references.next': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/:displayId/next',
    tokens: [{"old":"/projects/:id/references/:displayId/next","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/next","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/next","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/next","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/next","type":0,"val":"next","end":""}],
    types: placeholder as Registry['references.next']['types'],
  },
  'references.previous': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/references/:displayId/previous',
    tokens: [{"old":"/projects/:id/references/:displayId/previous","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:displayId/previous","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:displayId/previous","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:displayId/previous","type":1,"val":"displayId","end":""},{"old":"/projects/:id/references/:displayId/previous","type":0,"val":"previous","end":""}],
    types: placeholder as Registry['references.previous']['types'],
  },
  'references.updateStatus': {
    methods: ["PATCH"],
    pattern: '/references/:id/status',
    tokens: [{"old":"/references/:id/status","type":0,"val":"references","end":""},{"old":"/references/:id/status","type":1,"val":"id","end":""},{"old":"/references/:id/status","type":0,"val":"status","end":""}],
    types: placeholder as Registry['references.updateStatus']['types'],
  },
  'references.deleteAll': {
    methods: ["DELETE"],
    pattern: '/projects/:id/references',
    tokens: [{"old":"/projects/:id/references","type":0,"val":"projects","end":""},{"old":"/projects/:id/references","type":1,"val":"id","end":""},{"old":"/projects/:id/references","type":0,"val":"references","end":""}],
    types: placeholder as Registry['references.deleteAll']['types'],
  },
  'api.references.store': {
    methods: ["POST"],
    pattern: '/api/v1/projects/:id/references',
    tokens: [{"old":"/api/v1/projects/:id/references","type":0,"val":"api","end":""},{"old":"/api/v1/projects/:id/references","type":0,"val":"v1","end":""},{"old":"/api/v1/projects/:id/references","type":0,"val":"projects","end":""},{"old":"/api/v1/projects/:id/references","type":1,"val":"id","end":""},{"old":"/api/v1/projects/:id/references","type":0,"val":"references","end":""}],
    types: placeholder as Registry['api.references.store']['types'],
  },
  'ai_screening.start': {
    methods: ["POST"],
    pattern: '/projects/:id/ai-screening/start',
    tokens: [{"old":"/projects/:id/ai-screening/start","type":0,"val":"projects","end":""},{"old":"/projects/:id/ai-screening/start","type":1,"val":"id","end":""},{"old":"/projects/:id/ai-screening/start","type":0,"val":"ai-screening","end":""},{"old":"/projects/:id/ai-screening/start","type":0,"val":"start","end":""}],
    types: placeholder as Registry['ai_screening.start']['types'],
  },
  'ai_screening.current': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/ai-screening/current',
    tokens: [{"old":"/projects/:id/ai-screening/current","type":0,"val":"projects","end":""},{"old":"/projects/:id/ai-screening/current","type":1,"val":"id","end":""},{"old":"/projects/:id/ai-screening/current","type":0,"val":"ai-screening","end":""},{"old":"/projects/:id/ai-screening/current","type":0,"val":"current","end":""}],
    types: placeholder as Registry['ai_screening.current']['types'],
  },
  'ai_screening.cancel': {
    methods: ["DELETE"],
    pattern: '/ai-screening/jobs/:jobId',
    tokens: [{"old":"/ai-screening/jobs/:jobId","type":0,"val":"ai-screening","end":""},{"old":"/ai-screening/jobs/:jobId","type":0,"val":"jobs","end":""},{"old":"/ai-screening/jobs/:jobId","type":1,"val":"jobId","end":""}],
    types: placeholder as Registry['ai_screening.cancel']['types'],
  },
  'criteria.index': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/exclusion-criteria',
    tokens: [{"old":"/projects/:id/exclusion-criteria","type":0,"val":"projects","end":""},{"old":"/projects/:id/exclusion-criteria","type":1,"val":"id","end":""},{"old":"/projects/:id/exclusion-criteria","type":0,"val":"exclusion-criteria","end":""}],
    types: placeholder as Registry['criteria.index']['types'],
  },
  'criteria.store': {
    methods: ["POST"],
    pattern: '/projects/:id/exclusion-criteria',
    tokens: [{"old":"/projects/:id/exclusion-criteria","type":0,"val":"projects","end":""},{"old":"/projects/:id/exclusion-criteria","type":1,"val":"id","end":""},{"old":"/projects/:id/exclusion-criteria","type":0,"val":"exclusion-criteria","end":""}],
    types: placeholder as Registry['criteria.store']['types'],
  },
  'criteria.update': {
    methods: ["PATCH"],
    pattern: '/exclusion-criteria/:id',
    tokens: [{"old":"/exclusion-criteria/:id","type":0,"val":"exclusion-criteria","end":""},{"old":"/exclusion-criteria/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['criteria.update']['types'],
  },
  'criteria.destroy': {
    methods: ["DELETE"],
    pattern: '/exclusion-criteria/:id',
    tokens: [{"old":"/exclusion-criteria/:id","type":0,"val":"exclusion-criteria","end":""},{"old":"/exclusion-criteria/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['criteria.destroy']['types'],
  },
  'keywords.index': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/inclusion-exclusion-keywords',
    tokens: [{"old":"/projects/:id/inclusion-exclusion-keywords","type":0,"val":"projects","end":""},{"old":"/projects/:id/inclusion-exclusion-keywords","type":1,"val":"id","end":""},{"old":"/projects/:id/inclusion-exclusion-keywords","type":0,"val":"inclusion-exclusion-keywords","end":""}],
    types: placeholder as Registry['keywords.index']['types'],
  },
  'keywords.store': {
    methods: ["POST"],
    pattern: '/projects/:id/inclusion-exclusion-keywords',
    tokens: [{"old":"/projects/:id/inclusion-exclusion-keywords","type":0,"val":"projects","end":""},{"old":"/projects/:id/inclusion-exclusion-keywords","type":1,"val":"id","end":""},{"old":"/projects/:id/inclusion-exclusion-keywords","type":0,"val":"inclusion-exclusion-keywords","end":""}],
    types: placeholder as Registry['keywords.store']['types'],
  },
  'keywords.update': {
    methods: ["PATCH"],
    pattern: '/inclusion-exclusion-keywords/:id',
    tokens: [{"old":"/inclusion-exclusion-keywords/:id","type":0,"val":"inclusion-exclusion-keywords","end":""},{"old":"/inclusion-exclusion-keywords/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['keywords.update']['types'],
  },
  'keywords.destroy': {
    methods: ["DELETE"],
    pattern: '/inclusion-exclusion-keywords/:id',
    tokens: [{"old":"/inclusion-exclusion-keywords/:id","type":0,"val":"inclusion-exclusion-keywords","end":""},{"old":"/inclusion-exclusion-keywords/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['keywords.destroy']['types'],
  },
  'notes.notes_for_pdf': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/pdfs/:id/notes',
    tokens: [{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"api","end":""},{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"v1","end":""},{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"pdfs","end":""},{"old":"/api/v1/pdfs/:id/notes","type":1,"val":"id","end":""},{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"notes","end":""}],
    types: placeholder as Registry['notes.notes_for_pdf']['types'],
  },
  'notes.create_note_for_pdf': {
    methods: ["POST"],
    pattern: '/api/v1/pdfs/:id/notes',
    tokens: [{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"api","end":""},{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"v1","end":""},{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"pdfs","end":""},{"old":"/api/v1/pdfs/:id/notes","type":1,"val":"id","end":""},{"old":"/api/v1/pdfs/:id/notes","type":0,"val":"notes","end":""}],
    types: placeholder as Registry['notes.create_note_for_pdf']['types'],
  },
  'notes.destroy': {
    methods: ["DELETE"],
    pattern: '/api/v1/notes/:id',
    tokens: [{"old":"/api/v1/notes/:id","type":0,"val":"api","end":""},{"old":"/api/v1/notes/:id","type":0,"val":"v1","end":""},{"old":"/api/v1/notes/:id","type":0,"val":"notes","end":""},{"old":"/api/v1/notes/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['notes.destroy']['types'],
  },
  'pdf_full_text_screening.dev_retrigger_all': {
    methods: ["POST"],
    pattern: '/projects/:id/pdf-full-text-screening/dev-retrigger-all',
    tokens: [{"old":"/projects/:id/pdf-full-text-screening/dev-retrigger-all","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdf-full-text-screening/dev-retrigger-all","type":1,"val":"id","end":""},{"old":"/projects/:id/pdf-full-text-screening/dev-retrigger-all","type":0,"val":"pdf-full-text-screening","end":""},{"old":"/projects/:id/pdf-full-text-screening/dev-retrigger-all","type":0,"val":"dev-retrigger-all","end":""}],
    types: placeholder as Registry['pdf_full_text_screening.dev_retrigger_all']['types'],
  },
  'pdf_full_text_screening.start': {
    methods: ["POST"],
    pattern: '/projects/:id/pdf-full-text-screening/start',
    tokens: [{"old":"/projects/:id/pdf-full-text-screening/start","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdf-full-text-screening/start","type":1,"val":"id","end":""},{"old":"/projects/:id/pdf-full-text-screening/start","type":0,"val":"pdf-full-text-screening","end":""},{"old":"/projects/:id/pdf-full-text-screening/start","type":0,"val":"start","end":""}],
    types: placeholder as Registry['pdf_full_text_screening.start']['types'],
  },
  'pdf_full_text_screening.current': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pdf-full-text-screening/current',
    tokens: [{"old":"/projects/:id/pdf-full-text-screening/current","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdf-full-text-screening/current","type":1,"val":"id","end":""},{"old":"/projects/:id/pdf-full-text-screening/current","type":0,"val":"pdf-full-text-screening","end":""},{"old":"/projects/:id/pdf-full-text-screening/current","type":0,"val":"current","end":""}],
    types: placeholder as Registry['pdf_full_text_screening.current']['types'],
  },
  'pdf_full_text_screening.cancel': {
    methods: ["DELETE"],
    pattern: '/pdf-full-text-screening/jobs/:jobId',
    tokens: [{"old":"/pdf-full-text-screening/jobs/:jobId","type":0,"val":"pdf-full-text-screening","end":""},{"old":"/pdf-full-text-screening/jobs/:jobId","type":0,"val":"jobs","end":""},{"old":"/pdf-full-text-screening/jobs/:jobId","type":1,"val":"jobId","end":""}],
    types: placeholder as Registry['pdf_full_text_screening.cancel']['types'],
  },
  'projects.pdfs.index': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pdfs',
    tokens: [{"old":"/projects/:id/pdfs","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdfs","type":1,"val":"id","end":""},{"old":"/projects/:id/pdfs","type":0,"val":"pdfs","end":""}],
    types: placeholder as Registry['projects.pdfs.index']['types'],
  },
  'projects.pdfs.store': {
    methods: ["POST"],
    pattern: '/projects/:id/pdfs',
    tokens: [{"old":"/projects/:id/pdfs","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdfs","type":1,"val":"id","end":""},{"old":"/projects/:id/pdfs","type":0,"val":"pdfs","end":""}],
    types: placeholder as Registry['projects.pdfs.store']['types'],
  },
  'projects.references.pdfs.store': {
    methods: ["POST"],
    pattern: '/projects/:id/references/:referenceId/pdfs',
    tokens: [{"old":"/projects/:id/references/:referenceId/pdfs","type":0,"val":"projects","end":""},{"old":"/projects/:id/references/:referenceId/pdfs","type":1,"val":"id","end":""},{"old":"/projects/:id/references/:referenceId/pdfs","type":0,"val":"references","end":""},{"old":"/projects/:id/references/:referenceId/pdfs","type":1,"val":"referenceId","end":""},{"old":"/projects/:id/references/:referenceId/pdfs","type":0,"val":"pdfs","end":""}],
    types: placeholder as Registry['projects.references.pdfs.store']['types'],
  },
  'projects.pdfs.downloadAll': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pdfs/download-all',
    tokens: [{"old":"/projects/:id/pdfs/download-all","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdfs/download-all","type":1,"val":"id","end":""},{"old":"/projects/:id/pdfs/download-all","type":0,"val":"pdfs","end":""},{"old":"/projects/:id/pdfs/download-all","type":0,"val":"download-all","end":""}],
    types: placeholder as Registry['projects.pdfs.downloadAll']['types'],
  },
  'projects.pdfs.download': {
    methods: ["GET","HEAD"],
    pattern: '/projects/:id/pdfs/:pdfId/download',
    tokens: [{"old":"/projects/:id/pdfs/:pdfId/download","type":0,"val":"projects","end":""},{"old":"/projects/:id/pdfs/:pdfId/download","type":1,"val":"id","end":""},{"old":"/projects/:id/pdfs/:pdfId/download","type":0,"val":"pdfs","end":""},{"old":"/projects/:id/pdfs/:pdfId/download","type":1,"val":"pdfId","end":""},{"old":"/projects/:id/pdfs/:pdfId/download","type":0,"val":"download","end":""}],
    types: placeholder as Registry['projects.pdfs.download']['types'],
  },
  'projects.fetchPdfs': {
    methods: ["POST"],
    pattern: '/projects/:id/fetch-pdfs',
    tokens: [{"old":"/projects/:id/fetch-pdfs","type":0,"val":"projects","end":""},{"old":"/projects/:id/fetch-pdfs","type":1,"val":"id","end":""},{"old":"/projects/:id/fetch-pdfs","type":0,"val":"fetch-pdfs","end":""}],
    types: placeholder as Registry['projects.fetchPdfs']['types'],
  },
  'team.show': {
    methods: ["GET","HEAD"],
    pattern: '/team',
    tokens: [{"old":"/team","type":0,"val":"team","end":""}],
    types: placeholder as Registry['team.show']['types'],
  },
  'team.addMember': {
    methods: ["POST"],
    pattern: '/team/add-member',
    tokens: [{"old":"/team/add-member","type":0,"val":"team","end":""},{"old":"/team/add-member","type":0,"val":"add-member","end":""}],
    types: placeholder as Registry['team.addMember']['types'],
  },
  'team.updateRole': {
    methods: ["PUT"],
    pattern: '/team/update-role',
    tokens: [{"old":"/team/update-role","type":0,"val":"team","end":""},{"old":"/team/update-role","type":0,"val":"update-role","end":""}],
    types: placeholder as Registry['team.updateRole']['types'],
  },
  'team.removeMember': {
    methods: ["DELETE"],
    pattern: '/team/remove-member',
    tokens: [{"old":"/team/remove-member","type":0,"val":"team","end":""},{"old":"/team/remove-member","type":0,"val":"remove-member","end":""}],
    types: placeholder as Registry['team.removeMember']['types'],
  },
  'website.robots': {
    methods: ["GET","HEAD"],
    pattern: '/robots.txt',
    tokens: [{"old":"/robots.txt","type":0,"val":"robots.txt","end":""}],
    types: placeholder as Registry['website.robots']['types'],
  },
  'website.sitemap': {
    methods: ["GET","HEAD"],
    pattern: '/sitemap.xml',
    tokens: [{"old":"/sitemap.xml","type":0,"val":"sitemap.xml","end":""}],
    types: placeholder as Registry['website.sitemap']['types'],
  },
  'website.landing': {
    methods: ["GET","HEAD"],
    pattern: '/',
    tokens: [{"old":"/","type":0,"val":"/","end":""}],
    types: placeholder as Registry['website.landing']['types'],
  },
  'website.pricing': {
    methods: ["GET","HEAD"],
    pattern: '/pricing',
    tokens: [{"old":"/pricing","type":0,"val":"pricing","end":""}],
    types: placeholder as Registry['website.pricing']['types'],
  },
  'website.tools': {
    methods: ["GET","HEAD"],
    pattern: '/tools',
    tokens: [{"old":"/tools","type":0,"val":"tools","end":""}],
    types: placeholder as Registry['website.tools']['types'],
  },
  'website.blog': {
    methods: ["GET","HEAD"],
    pattern: '/blog',
    tokens: [{"old":"/blog","type":0,"val":"blog","end":""}],
    types: placeholder as Registry['website.blog']['types'],
  },
  'website.blog.post': {
    methods: ["GET","HEAD"],
    pattern: '/blog/:slug',
    tokens: [{"old":"/blog/:slug","type":0,"val":"blog","end":""},{"old":"/blog/:slug","type":1,"val":"slug","end":""}],
    types: placeholder as Registry['website.blog.post']['types'],
  },
  'website.our-story': {
    methods: ["GET","HEAD"],
    pattern: '/our-story',
    tokens: [{"old":"/our-story","type":0,"val":"our-story","end":""}],
    types: placeholder as Registry['website.our-story']['types'],
  },
  'website.careers': {
    methods: ["GET","HEAD"],
    pattern: '/careers',
    tokens: [{"old":"/careers","type":0,"val":"careers","end":""}],
    types: placeholder as Registry['website.careers']['types'],
  },
  'website.privacy': {
    methods: ["GET","HEAD"],
    pattern: '/privacy',
    tokens: [{"old":"/privacy","type":0,"val":"privacy","end":""}],
    types: placeholder as Registry['website.privacy']['types'],
  },
  'website.security': {
    methods: ["GET","HEAD"],
    pattern: '/security',
    tokens: [{"old":"/security","type":0,"val":"security","end":""}],
    types: placeholder as Registry['website.security']['types'],
  },
  'website.terms': {
    methods: ["GET","HEAD"],
    pattern: '/terms',
    tokens: [{"old":"/terms","type":0,"val":"terms","end":""}],
    types: placeholder as Registry['website.terms']['types'],
  },
  'website.policies': {
    methods: ["GET","HEAD"],
    pattern: '/policies',
    tokens: [{"old":"/policies","type":0,"val":"policies","end":""}],
    types: placeholder as Registry['website.policies']['types'],
  },
  'website.contact': {
    methods: ["GET","HEAD"],
    pattern: '/contact',
    tokens: [{"old":"/contact","type":0,"val":"contact","end":""}],
    types: placeholder as Registry['website.contact']['types'],
  },
  'website.demo-requests': {
    methods: ["POST"],
    pattern: '/demo-requests',
    tokens: [{"old":"/demo-requests","type":0,"val":"demo-requests","end":""}],
    types: placeholder as Registry['website.demo-requests']['types'],
  },
  'admin.blog.index': {
    methods: ["GET","HEAD"],
    pattern: '/admin/blog',
    tokens: [{"old":"/admin/blog","type":0,"val":"admin","end":""},{"old":"/admin/blog","type":0,"val":"blog","end":""}],
    types: placeholder as Registry['admin.blog.index']['types'],
  },
  'admin.blog.show': {
    methods: ["GET","HEAD"],
    pattern: '/admin/blog/:id',
    tokens: [{"old":"/admin/blog/:id","type":0,"val":"admin","end":""},{"old":"/admin/blog/:id","type":0,"val":"blog","end":""},{"old":"/admin/blog/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['admin.blog.show']['types'],
  },
  'admin.blog.publish': {
    methods: ["POST"],
    pattern: '/admin/blog/:id/publish',
    tokens: [{"old":"/admin/blog/:id/publish","type":0,"val":"admin","end":""},{"old":"/admin/blog/:id/publish","type":0,"val":"blog","end":""},{"old":"/admin/blog/:id/publish","type":1,"val":"id","end":""},{"old":"/admin/blog/:id/publish","type":0,"val":"publish","end":""}],
    types: placeholder as Registry['admin.blog.publish']['types'],
  },
  'admin.blog.unpublish': {
    methods: ["POST"],
    pattern: '/admin/blog/:id/unpublish',
    tokens: [{"old":"/admin/blog/:id/unpublish","type":0,"val":"admin","end":""},{"old":"/admin/blog/:id/unpublish","type":0,"val":"blog","end":""},{"old":"/admin/blog/:id/unpublish","type":1,"val":"id","end":""},{"old":"/admin/blog/:id/unpublish","type":0,"val":"unpublish","end":""}],
    types: placeholder as Registry['admin.blog.unpublish']['types'],
  },
  'clarity.collect': {
    methods: ["POST","OPTIONS"],
    pattern: '/api/v1/clarity/collect',
    tokens: [{"old":"/api/v1/clarity/collect","type":0,"val":"api","end":""},{"old":"/api/v1/clarity/collect","type":0,"val":"v1","end":""},{"old":"/api/v1/clarity/collect","type":0,"val":"clarity","end":""},{"old":"/api/v1/clarity/collect","type":0,"val":"collect","end":""}],
    types: placeholder as Registry['clarity.collect']['types'],
  },
  'clarity.tag': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/clarity/tag/:projectId',
    tokens: [{"old":"/api/v1/clarity/tag/:projectId","type":0,"val":"api","end":""},{"old":"/api/v1/clarity/tag/:projectId","type":0,"val":"v1","end":""},{"old":"/api/v1/clarity/tag/:projectId","type":0,"val":"clarity","end":""},{"old":"/api/v1/clarity/tag/:projectId","type":0,"val":"tag","end":""},{"old":"/api/v1/clarity/tag/:projectId","type":1,"val":"projectId","end":""}],
    types: placeholder as Registry['clarity.tag']['types'],
  },
  'health_checks': {
    methods: ["GET","HEAD"],
    pattern: '/health',
    tokens: [{"old":"/health","type":0,"val":"health","end":""}],
    types: placeholder as Registry['health_checks']['types'],
  },
  'api.job_events.last': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/projects/:id/job-events/:jobName',
    tokens: [{"old":"/api/v1/projects/:id/job-events/:jobName","type":0,"val":"api","end":""},{"old":"/api/v1/projects/:id/job-events/:jobName","type":0,"val":"v1","end":""},{"old":"/api/v1/projects/:id/job-events/:jobName","type":0,"val":"projects","end":""},{"old":"/api/v1/projects/:id/job-events/:jobName","type":1,"val":"id","end":""},{"old":"/api/v1/projects/:id/job-events/:jobName","type":0,"val":"job-events","end":""},{"old":"/api/v1/projects/:id/job-events/:jobName","type":1,"val":"jobName","end":""}],
    types: placeholder as Registry['api.job_events.last']['types'],
  },
  'queuedash.trpc': {
    methods: ["HEAD","OPTIONS","GET","POST","PUT","PATCH","DELETE"],
    pattern: '/admin/queues/trpc/*',
    tokens: [{"old":"/admin/queues/trpc/*","type":0,"val":"admin","end":""},{"old":"/admin/queues/trpc/*","type":0,"val":"queues","end":""},{"old":"/admin/queues/trpc/*","type":0,"val":"trpc","end":""},{"old":"/admin/queues/trpc/*","type":2,"val":"*","end":""}],
    types: placeholder as Registry['queuedash.trpc']['types'],
  },
  'queuedash.main': {
    methods: ["GET","HEAD"],
    pattern: '/admin/queues/main.mjs',
    tokens: [{"old":"/admin/queues/main.mjs","type":0,"val":"admin","end":""},{"old":"/admin/queues/main.mjs","type":0,"val":"queues","end":""},{"old":"/admin/queues/main.mjs","type":0,"val":"main.mjs","end":""}],
    types: placeholder as Registry['queuedash.main']['types'],
  },
  'queuedash.styles': {
    methods: ["GET","HEAD"],
    pattern: '/admin/queues/styles.css',
    tokens: [{"old":"/admin/queues/styles.css","type":0,"val":"admin","end":""},{"old":"/admin/queues/styles.css","type":0,"val":"queues","end":""},{"old":"/admin/queues/styles.css","type":0,"val":"styles.css","end":""}],
    types: placeholder as Registry['queuedash.styles']['types'],
  },
  'queuedash.index': {
    methods: ["GET","HEAD"],
    pattern: '/admin/queues',
    tokens: [{"old":"/admin/queues","type":0,"val":"admin","end":""},{"old":"/admin/queues","type":0,"val":"queues","end":""}],
    types: placeholder as Registry['queuedash.index']['types'],
  },
  'queuedash.catchAll': {
    methods: ["GET","HEAD"],
    pattern: '/admin/queues/*',
    tokens: [{"old":"/admin/queues/*","type":0,"val":"admin","end":""},{"old":"/admin/queues/*","type":0,"val":"queues","end":""},{"old":"/admin/queues/*","type":2,"val":"*","end":""}],
    types: placeholder as Registry['queuedash.catchAll']['types'],
  },
  'sentry.proxy': {
    methods: ["HEAD","OPTIONS","GET","POST","PUT","PATCH","DELETE"],
    pattern: '/api/v1/monitoring',
    tokens: [{"old":"/api/v1/monitoring","type":0,"val":"api","end":""},{"old":"/api/v1/monitoring","type":0,"val":"v1","end":""},{"old":"/api/v1/monitoring","type":0,"val":"monitoring","end":""}],
    types: placeholder as Registry['sentry.proxy']['types'],
  },
  'mcp.post': {
    methods: ["POST"],
    pattern: '/mcp',
    tokens: [{"old":"/mcp","type":0,"val":"mcp","end":""}],
    types: placeholder as Registry['mcp.post']['types'],
  },
  'mcp.metadata': {
    methods: ["GET","HEAD"],
    pattern: '/.well-known/oauth-protected-resource',
    tokens: [{"old":"/.well-known/oauth-protected-resource","type":0,"val":".well-known","end":""},{"old":"/.well-known/oauth-protected-resource","type":0,"val":"oauth-protected-resource","end":""}],
    types: placeholder as Registry['mcp.metadata']['types'],
  },
  'mcp.metadata.scoped': {
    methods: ["GET","HEAD"],
    pattern: '/.well-known/oauth-protected-resource/mcp',
    tokens: [{"old":"/.well-known/oauth-protected-resource/mcp","type":0,"val":".well-known","end":""},{"old":"/.well-known/oauth-protected-resource/mcp","type":0,"val":"oauth-protected-resource","end":""},{"old":"/.well-known/oauth-protected-resource/mcp","type":0,"val":"mcp","end":""}],
    types: placeholder as Registry['mcp.metadata.scoped']['types'],
  },
  'event_stream': {
    methods: ["GET","HEAD"],
    pattern: '/__transmit/events',
    tokens: [{"old":"/__transmit/events","type":0,"val":"__transmit","end":""},{"old":"/__transmit/events","type":0,"val":"events","end":""}],
    types: placeholder as Registry['event_stream']['types'],
  },
  'subscribe': {
    methods: ["POST"],
    pattern: '/__transmit/subscribe',
    tokens: [{"old":"/__transmit/subscribe","type":0,"val":"__transmit","end":""},{"old":"/__transmit/subscribe","type":0,"val":"subscribe","end":""}],
    types: placeholder as Registry['subscribe']['types'],
  },
  'unsubscribe': {
    methods: ["POST"],
    pattern: '/__transmit/unsubscribe',
    tokens: [{"old":"/__transmit/unsubscribe","type":0,"val":"__transmit","end":""},{"old":"/__transmit/unsubscribe","type":0,"val":"unsubscribe","end":""}],
    types: placeholder as Registry['unsubscribe']['types'],
  },
} as const satisfies Record<string, AdonisEndpoint>

export { routes }

export const registry = {
  routes,
  $tree: {} as ApiDefinition,
}

declare module '@tuyau/core/types' {
  export interface UserRegistry {
    routes: typeof routes
    $tree: ApiDefinition
  }
}
